/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  EnableShopShieldRequest,
  Error,
  GetShopShieldURIResponse,
  ListShopShieldURIsResponse,
  ListSiteShopShieldsParams,
  ShopShieldURIID,
  SiteID,
  SuccessResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Lists URLs on a site where Shop Shield traffic protection is enabled. Search and filter by path.
 * @summary List protected pages
 */
export const listSiteShopShields = (
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListShopShieldURIsResponse>({
    url: `/v1/sites/${id}/shop_shield`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteShopShieldsQueryKey = (id?: SiteID, params?: ListSiteShopShieldsParams) => {
  return [`/v1/sites/${id}/shop_shield`, ...(params ? [params] : [])] as const;
};

export const getListSiteShopShieldsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteShopShieldsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteShopShields>>> = ({ signal }) =>
    listSiteShopShields(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/shop_shield`,
      operationId: 'app.controllers.shop_shield_controller.list_site_shop_shields',
      operationName: 'listSiteShopShields',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteShopShields>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteShopShieldsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteShopShields>>
>;
export type ListSiteShopShieldsQueryError = Error;

export function useListSiteShopShields<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteShopShieldsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteShopShields>>,
          TError,
          Awaited<ReturnType<typeof listSiteShopShields>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteShopShields<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteShopShields>>,
          TError,
          Awaited<ReturnType<typeof listSiteShopShields>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteShopShields<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List protected pages
 */

export function useListSiteShopShields<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteShopShieldsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteShopShieldsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteShopShieldsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteShopShields>>> = ({ signal }) =>
    listSiteShopShields(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/shop_shield`,
      operationId: 'app.controllers.shop_shield_controller.list_site_shop_shields',
      operationName: 'listSiteShopShields',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteShopShields>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteShopShieldsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteShopShields>>
>;
export type ListSiteShopShieldsSuspenseQueryError = Error;

export function useListSiteShopShieldsSuspense<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteShopShieldsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteShopShieldsSuspense<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteShopShieldsSuspense<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List protected pages
 */

export function useListSiteShopShieldsSuspense<
  TData = Awaited<ReturnType<typeof listSiteShopShields>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteShopShieldsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteShopShields>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteShopShieldsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Turns on Shop Shield for a URL path (for example, /shop or /) to handle traffic spikes. Optionally notify the site owner.
 * @summary Enable traffic protection
 */
export const enableSiteShopShield = (
  id: SiteID,
  enableShopShieldRequest: EnableShopShieldRequest,
  signal?: AbortSignal
) => {
  return customFetch<GetShopShieldURIResponse>({
    url: `/v1/sites/${id}/shop_shield`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: enableShopShieldRequest,
    signal,
  });
};

export const getEnableSiteShopShieldMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof enableSiteShopShield>>,
    TError,
    { id: SiteID; data: EnableShopShieldRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof enableSiteShopShield>>,
  TError,
  { id: SiteID; data: EnableShopShieldRequest },
  TContext
> => {
  const mutationKey = ['enableSiteShopShield'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof enableSiteShopShield>>,
    { id: SiteID; data: EnableShopShieldRequest }
  > = props => {
    const { id, data } = props ?? {};

    return enableSiteShopShield(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/shop_shield` },
    {
      operationId: 'app.controllers.shop_shield_controller.enable_site_shop_shield',
      operationName: 'enableSiteShopShield',
    }
  );

  return customOptions;
};

export type EnableSiteShopShieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof enableSiteShopShield>>
>;
export type EnableSiteShopShieldMutationBody = EnableShopShieldRequest;
export type EnableSiteShopShieldMutationError = Error;

/**
 * @summary Enable traffic protection
 */
export const useEnableSiteShopShield = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof enableSiteShopShield>>,
      TError,
      { id: SiteID; data: EnableShopShieldRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof enableSiteShopShield>>,
  TError,
  { id: SiteID; data: EnableShopShieldRequest },
  TContext
> => {
  const mutationOptions = getEnableSiteShopShieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Turns off Shop Shield for a protected URL path.
 * @summary Disable traffic protection
 */
export const disableSiteShopShield = (id: SiteID, uriId: ShopShieldURIID) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/shop_shield/${uriId}`,
    method: 'DELETE',
  });
};

export const getDisableSiteShopShieldMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disableSiteShopShield>>,
    TError,
    { id: SiteID; uriId: ShopShieldURIID },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disableSiteShopShield>>,
  TError,
  { id: SiteID; uriId: ShopShieldURIID },
  TContext
> => {
  const mutationKey = ['disableSiteShopShield'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disableSiteShopShield>>,
    { id: SiteID; uriId: ShopShieldURIID }
  > = props => {
    const { id, uriId } = props ?? {};

    return disableSiteShopShield(id, uriId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/shop_shield/{uriId}` },
    {
      operationId: 'app.controllers.shop_shield_controller.disable_site_shop_shield',
      operationName: 'disableSiteShopShield',
    }
  );

  return customOptions;
};

export type DisableSiteShopShieldMutationResult = NonNullable<
  Awaited<ReturnType<typeof disableSiteShopShield>>
>;

export type DisableSiteShopShieldMutationError = Error;

/**
 * @summary Disable traffic protection
 */
export const useDisableSiteShopShield = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disableSiteShopShield>>,
      TError,
      { id: SiteID; uriId: ShopShieldURIID },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof disableSiteShopShield>>,
  TError,
  { id: SiteID; uriId: ShopShieldURIID },
  TContext
> => {
  const mutationOptions = getDisableSiteShopShieldMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns configuration and timestamps for one Shop Shield protected path.
 * @summary Get protected page details
 */
export const findSiteShopShield = (id: SiteID, uriId: ShopShieldURIID, signal?: AbortSignal) => {
  return customFetch<GetShopShieldURIResponse>({
    url: `/v1/sites/${id}/shop_shield/${uriId}`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteShopShieldQueryKey = (id?: SiteID, uriId?: ShopShieldURIID) => {
  return [`/v1/sites/${id}/shop_shield/${uriId}`] as const;
};

export const getFindSiteShopShieldQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteShopShieldQueryKey(id, uriId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteShopShield>>> = ({ signal }) =>
    findSiteShopShield(id, uriId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, uriId },
    {
      url: `/v1/sites/${id}/shop_shield/${uriId}`,
      operationId: 'app.controllers.shop_shield_controller.find_site_shop_shield',
      operationName: 'findSiteShopShield',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteShopShield>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteShopShieldQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteShopShield>>
>;
export type FindSiteShopShieldQueryError = Error;

export function useFindSiteShopShield<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteShopShield>>,
          TError,
          Awaited<ReturnType<typeof findSiteShopShield>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteShopShield<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteShopShield>>,
          TError,
          Awaited<ReturnType<typeof findSiteShopShield>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteShopShield<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get protected page details
 */

export function useFindSiteShopShield<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteShopShieldQueryOptions(id, uriId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteShopShieldSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteShopShieldQueryKey(id, uriId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteShopShield>>> = ({ signal }) =>
    findSiteShopShield(id, uriId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, uriId },
    {
      url: `/v1/sites/${id}/shop_shield/${uriId}`,
      operationId: 'app.controllers.shop_shield_controller.find_site_shop_shield',
      operationName: 'findSiteShopShield',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteShopShield>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteShopShieldSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteShopShield>>
>;
export type FindSiteShopShieldSuspenseQueryError = Error;

export function useFindSiteShopShieldSuspense<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteShopShieldSuspense<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteShopShieldSuspense<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get protected page details
 */

export function useFindSiteShopShieldSuspense<
  TData = Awaited<ReturnType<typeof findSiteShopShield>>,
  TError = Error,
>(
  id: SiteID,
  uriId: ShopShieldURIID,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteShopShield>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteShopShieldSuspenseQueryOptions(id, uriId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
